import { adminHttpClient } from '../../../commons/adminHttpClient'
import localStorage from '../../../commons/localStorage'
import OrderedPageFilter from '../../../commons/orderedPageFilter'
import PagedList from '../../../commons/pagedList'

export const getTemplateurl = (): Promise<any> => {
  return adminHttpClient.get('/IchraDecisionTool/ProspectApplication/Step3/EmployeeCensusTemplateUrl')
}

export const uploadCensusTemplate = (file: File): Promise<any> => {
  const code = localStorage.getProspectSignupCode()

  let formData = new FormData()
  formData.append('file', file)
  formData.append('token', code ?? '')

  return adminHttpClient.put('/IchraDecisionTool/ProspectApplication/Step3/UploadEmployeeCensus', formData, {
    headers: {
      'Content-Type': 'text/csv',
    },
  })
}

export interface PagedEmployees extends PagedList<Employee> {}

export interface Employee {
  identifier: string
  zipCode: string
  birthDate: string
  gender: string
  annualSalary: number
  compensationMethod: string
  status: string
  isSpouse: boolean
  hasDependents: boolean
  participatingGHP: boolean | null
}

export const getEmployees = (filter: OrderedPageFilter): Promise<PagedEmployees> => {
  const code = localStorage.getProspectSignupCode()

  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'identifier',
    orderDescending: true,
  }
  return adminHttpClient.get('/IchraDecisionTool/ProspectApplication/Step3/Employees', { ...filter, token: code })
}

export const finishSignup = (): Promise<any> => {
  const code = localStorage.getProspectSignupCode()
  return adminHttpClient.post('/IchraDecisionTool/ProspectApplication/Step3/FinishApplication', {
    token: code,
  })
}
